<script setup>
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import InputField from '@js/components/fields/InputField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { toastError, toastSuccess } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { tenant, emailing, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    emailing: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const isOpen = ref(false);

const isSubmitting = ref(false);

const form = reactive({
    name: emailing.name + ' (réplique)',
});

const validationSchema = object({
    name: string().required('Le nom est requis'),
    date: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.projectManagement.modules.postReplicateEmailing', {
                tenant: tenant.id,
                emailing: emailing.id,
            }),
            {
                name: form.name,
                date: form.date,
            },
        )
        .then(() => {
            toastSuccess('Réplique créée avec succès');
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .catch(() => {
            toastError(
                'Une erreur est survenue lors de la création de la réplique',
            );
        })
        .finally(() => {
            isSubmitting.value = false;
        });
}
</script>

<template>
    <DialogModal v-model="isOpen" size="small">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Répliquer l'emailing #{{ emailing.id }} </template>

        <template #full-content>
            <FormRoot
                :submit="submit"
                :validation-schema="validationSchema"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <InputField
                            v-model="form.name"
                            label="Nom"
                            field-name="name"
                            field-id="name"
                            type="text"
                            required
                        />

                        <InputField
                            v-model="form.date"
                            label="Date"
                            field-name="date"
                            field-id="date"
                            type="datetime-local"
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                    submit-text="Répliquer"
                />
            </FormRoot>
        </template>
    </DialogModal>
</template>
